import React from 'react';
import PropTypes from 'prop-types';
import useLanguage from '../../../hooks/useLanguage';

import Icon from '../../../svg/quote.svg';

const Quote = ({ quoteData }) => {
  const langToggle = useLanguage;
  return (
    <section className="quote" data-scroll-section>
      <div className="content-wrapper">
        <div className="quote-wrapper">
          <span className="quote-icon__wrapper">
            <Icon className="quote-icon" />
          </span>
          <p className="quote-title">
            {langToggle(quoteData.quote_ua, quoteData.quote_ru)}
          </p>
        </div>
      </div>
    </section>
  );
};

Quote.propTypes = {
  quoteData: PropTypes.object,
};

export default Quote;
